<template>
    <div>
        <el-dialog title="考评记录" width="80%" :visible="assessmentRecordDialogVisible" @close="close" center>

            <el-row class="bottom20">
                <el-select multiple
                           collapse-tags
                           v-model="categoryIds"
                           class="width30"
                           placeholder="请选择" size="mini">
                    <el-option
                            v-for="item in level2CategoryArr"
                            :key="item.config.id"
                            :label="item.config.category"
                            :value="item.config.id">
                    </el-option>
                </el-select>
            </el-row>

            <el-row class="bottom20">
                <el-table :data="filterTableData">
                    <el-table-column prop="config.seq" label="序号" width="120">
                    </el-table-column>
                    <el-table-column prop="config.manualSeq" label="条款编号" width="150">
                    </el-table-column>
                    <el-table-column prop="config.category" label="评分项" min-width="280">
                    </el-table-column>
                    <el-table-column prop="config.standardsOfGrading" label="评分标准" min-width="280">
                    </el-table-column>
                    <el-table-column prop="deductscore" label="扣分值" width="120">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.deductscore" @keyup.native="handleScoreInput(scope.row, 'deductscore')" :readonly="readOnly"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="评分备注" min-width="280">
                        <template slot-scope="scope">
                            <el-input type="textarea" v-model="scope.row.remark" maxlength="500" :readonly="readOnly"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>

            <el-row style="text-align: center">
                <el-button center="true" type="primary" @click="save()" :disabled="readOnly">确 定</el-button>
                <el-button center @click="close()">关 闭</el-button>
            </el-row>

        </el-dialog>

    </div>
</template>

<script>

    import AssessmentServer from "../../../api/assessment";

    export default {
        name: "assessmentRecordDialog",

        props: ['assessmentRecordDialogVisible', 'tableData', 'level2CategoryArr', 'level2SelectedCategoryIds', "readOnly"],

        data() {
            return {
                categoryIds: [],
                filterTableData: [],
            }
        },

        mounted() {

        },

        beforeUpdate() {

        },

        watch: {

            level2CategoryArr: {
                immediate: true,
                deep: true,
                handler: function (newVal, oldVal) {
                    if(newVal.length == 1){
                        this.categoryIds = [newVal[0].config.id];
                        this.filterTableData = this.tableData;
                    }
                }
            },

            categoryIds: {
                immediate: true,
                deep: true,
                handler: function (newVal, oldVal) {
                    this.filterTableData = this.tableData.filter(e => {
                        if (newVal.includes(e.config.parent)) {
                            return e;
                        }
                    })
                }
            },

        },

        methods: {

            save() {

                if(this.filterTableData.length == 0){
                    this.$message.error("请选择考评类别！");
                    return;
                }
                let tmpTableData = JSON.parse(JSON.stringify(this.filterTableData));
                tmpTableData = tmpTableData.map(e => {
                    e.deductscore = 0 - Number.parseFloat(e.deductscore);
                    return e;
                });
                AssessmentServer.assessmentRecord.batchUpdate(tmpTableData).then(responseBody => {
                    this.$message.success("保存成功");
                    this.close();
                });

            },

            close() {
                this.categoryIds = [];
                this.$emit('afterCloseAssessmentRecordDialog');
            },

            handleScoreInput(row, property) {
                try {
                    row[property] = row[property].match(/\d*(\.?\d{0,1})/g)[0];
                } catch (e) {
                    console.warn(e);
                }
            },

        },

    }
</script>

<style scoped>

</style>